interface SaveIndicatorProps {
  status?: "saved" | "saving" | "failed" | "offline" | "unsaved" | "recovered";
}

const STATUS_LABELS = {
  saved: "Saved on this device",
  saving: "Saving…",
  failed: "Save failed",
  offline: "Offline · saved on this device",
  unsaved: "Unsaved",
  recovered: "Recovered previous save",
} as const;

export function SaveIndicator({ status = "saved" }: SaveIndicatorProps) {
  return (
    <span className={`save-indicator save-indicator--${status}`} role="status">
      <span className="save-indicator__dot" aria-hidden="true" />
      {STATUS_LABELS[status]}
    </span>
  );
}
